import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
import { Table, TableBody, TableCell, TableHeaderCell, TableRow, Button, Form, Header, Checkbox, Loader,Icon } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import { useStore } from "../../../app/stores/store";
import { DaywiseHourAnalysis } from "../../../app/models/Restoration";

const DaywiseHoursAnalyzer = () => {
  const { RestorationStore, PivotStore } = useStore();
  const [loadData, setLoadData] = useState<DaywiseHourAnalysis[]>([]);
  const currentDate = new Date();
  const [startDate, setStartDate] = useState(() => moment(currentDate).startOf('month').format('MM-DD-YYYY'));
  const [endDate, setEndDate] = useState(() => moment(currentDate).format('MM-DD-YYYY'));
  const [checkedTitle, SetcheckedTitle] = useState<boolean>(false);
  const [dayHour,setdayHour]=useState<boolean>(false);
  const [loading, setLoader] = useState<boolean>(true);
  const setDate = (data: any, type: string) => {
    try {
      if (type === 'start') {
        setStartDate(moment(data).format('MM-DD-YYYY'));
      } else {
        setEndDate(moment(data).format('MM-DD-YYYY'));
      }
    } catch (error) {
      toast.error('Error fetching Date');
    }
  };

  const ApiCall = async () => {
    try {
        setLoader(true);
      await RestorationStore.DaywiseHoursAnalyzer(startDate, endDate, checkedTitle,dayHour);
      setLoadData(RestorationStore.DayWiseHours);
      setLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Error fetching data');
    }
    
  };

  useEffect(() => {
    ApiCall();
    // eslint-disable-next-line
  }, [checkedTitle,dayHour])

  const titleCodeCheckboxChange = () => {
    SetcheckedTitle(!checkedTitle);
  };
  const AchivedCheckboxChange = () => {
    setdayHour(!dayHour); 
  };
  const CsvConvert=()=>{
    const rows=[];
    
    const titleCodeRow=[
        'Date',
        'Title Code',
        'PL Name',
        'Cluster Name',
        'Employee ID',
        'Employee Name',
        'WorkingHours',
        'ExtraHours',
        'TotalHours',
        'Daily Hour Achieved'
    ];
    const dateRow=[
        'Date',
        'PL Name',
        'Cluster Name',
        'Employee ID',
        'Employee Name',
        'WorkingHours',
        'ExtraHours',
        'TotalHours',
        'Daily Hour Achieved'
    ];
    if(checkedTitle===true)
        {     
            rows.push(titleCodeRow.join(','));
        }
    if(checkedTitle===false)
        {
            rows.push(dateRow.join(','))
        }
    loadData.forEach(item => {
        const values = Object.values(item);
        rows.push(values.join(','));
    });
    const csvContent = rows.join('\n');
    return csvContent;
  }
  const handleDownload = () => {
    const csvContent = CsvConvert();
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `From_${startDate}_to_${endDate}_HoneyCombAttendanceHour.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

  return (
    <>
      <div className="title-wise-table" >
        <Header> HoneyComb Attendance Hour </Header>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center'}}>
            <h4 > From Date  </h4>
            <DatePicker
              placeholderText="From Date"
              value={
                startDate
                  ? PivotStore.dateFormat(
                    moment(startDate).format('MM-DD-YYYY'),
                  )
                  : ''
              }
              className="date-picker-style"
              showMonthDropdown
              showYearDropdown
              locale={'en'}
              dateFormatCalendar="MMMM"
              yearDropdownItemNumber={15}
              maxDate={moment().toDate()}
              scrollableYearDropdown
              onChange={(date: any) => setDate(date, 'start')}
              popperProps={{ strategy: 'fixed' }}
            />
            <Form.Field required={true}>
              
                <div style={{ display: 'flex', alignItems: 'center'}}>
                  <h4> To Date{' '} </h4>
                  <DatePicker
                    placeholderText="To Date"
                    value={
                      endDate
                        ? PivotStore.dateFormat(
                          moment(endDate).format('MM-DD-YYYY'),
                        )
                        : ''
                    }
                    className="date-picker-style"
                    showMonthDropdown
                    showYearDropdown
                    locale={'en'}
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={15}
                    maxDate={moment().toDate()}
                    scrollableYearDropdown
                    onChange={(date: any) => setDate(date, 'end')}
                    popperProps={{ strategy: 'fixed' }}
                  />
              
              </div>
            </Form.Field>
            </div>
            <div style={{ display: 'flex', alignItems: 'center'}}>
            <Form.Field>
              <Checkbox label={{ children: 'Show Title Code Breakup' }}
                checked={checkedTitle}
                onChange={titleCodeCheckboxChange}
              />
            </Form.Field>
            </div>
            <div style={{ display: 'flex', alignItems: 'center'}}>
            <Form.Field>
              <Checkbox label={{ children: 'Below 8hrs Achieved' }}
                checked={dayHour}
                onChange={AchivedCheckboxChange}
              />
            </Form.Field>
            </div>
            <div style={{ display: 'flex', alignItems: 'center'}}>
            <Form.Field>
              <Button
                primary
                onClick={ApiCall}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingRight: '20px',
                  paddingBottom: '10px',
                }}
              >
                View Report
              </Button>
            </Form.Field>
            </div>
            <div style={{ display: 'flex', alignItems: 'center'}}>
            <Form.Field>
                <div style={{ display: 'flex', alignItems: 'center'}}>
                  {loadData.length !== 0 && (<Button onClick={handleDownload}><Icon className='download'/></Button>)}
                  </div>
              </Form.Field>
          </div>
      
        </div>
        {loading ? <Loader active inline='centered' > Loading </Loader>:
        <div style={{maxHeight: '60vh', overflowY: 'auto' , marginTop: '50px'}}>
          <Table className='celled padded'>
            <Table.Header>
              <Table.Row>
                <TableHeaderCell>Date</TableHeaderCell>
                {checkedTitle === true && <TableHeaderCell>Title Code</TableHeaderCell>}
                <TableHeaderCell>Cluster Name</TableHeaderCell>
                <TableHeaderCell>Employee ID</TableHeaderCell>
                <TableHeaderCell>Employee Name</TableHeaderCell>
                <TableHeaderCell>Working Hours</TableHeaderCell>
                <TableHeaderCell>Extra Hours</TableHeaderCell>
                <TableHeaderCell>Total Hours</TableHeaderCell>
                {checkedTitle === false && <TableHeaderCell> Daily Hour Achieved </TableHeaderCell>}
              </Table.Row>
            </Table.Header>
            <TableBody >
              {loadData.length === 0 && (
                <Table.Row>
                  <Table.Cell colSpan={6} textAlign="center">
                    Currently Data not Available
                  </Table.Cell>
                </Table.Row>
              )}
              {loadData.map((item, index) => (
              
                <TableRow key={index} style={item.isAchieved ? {}:{color:'red'}}>
                  <TableCell>{item.date}</TableCell>
                  {checkedTitle === true && <TableCell>{item.titlecode}</TableCell>}
                  <TableCell>{item.clusterName}</TableCell>
                  <TableCell>{item.employee_ID}</TableCell>
                  <TableCell>{item.employee_Name}</TableCell>
                  <TableCell>{item.workingHours}</TableCell>
                  <TableCell>{item.extraHours}</TableCell>
                  <TableCell>{item.totalHours}</TableCell>
                  {checkedTitle === false && <TableCell>{item.isAchieved===true ? "Yes":"No" }</TableCell> }
                </TableRow>
              ))}
            </TableBody>
          </Table>
          </div>
          }
      </div>
      
    </>
  )
}

export default DaywiseHoursAnalyzer
